export default __webpack_public_path__ + "static/media/icon_download.ae15b208.svg";